var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account__section help"},[_c('ul',{staticClass:"help__actions"},_vm._l((_vm.helpActions),function(action,index){return _c('HelpAction',{key:index,attrs:{"icon":action.icon,"text":action.text,"href":action.href,"hasCaret":_vm.hasCaret,"show":action.show}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }